import type { KpiCardSpec } from './card-spec';

/**
 * The Email opt-ins scalar, shown on the Acquisition page's Pulse row and the
 * Users page's User acquisition section. Sits beside Total users on both: the
 * two are the standing counts, answering "how many are there now".
 */
export const EMAIL_OPT_INS_SCALAR_CARD: KpiCardSpec = {
    title: 'Email opt-ins',
    source: 'opt-ins',
    form: 'number',
    metric: 'emailOptIns',
    size: 'sm',
    description:
        'Users currently opted in to email, following the page Region filter. The Period does not move it and no delta is shown: no opt-in date is recorded, so the figure is a standing total of the whole base, not a count of the selected period.',
};
